import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Transform,
} from 'class-transformer';
import { CompensationPlan } from './enums/CompensationPlan';

export class Module {
  @Expose({ name: 'compensation_plan' })
  compensationPlan: CompensationPlan;

  @Expose({ name: 'package' })
  packages: boolean;
  upgrade: boolean;
  autoship: boolean;
  rank: boolean;

  @Expose({ name: 'direct_bonus' })
  directBonus: boolean;

  @Expose({ name: 'unilevel_bonus' })
  unilevelBonus: boolean;

  @Expose({ name: 'repurchase_bonus' })
  repurchaseBonus: boolean;

  @Expose({ name: 'roi_bonus' })
  roiBonus: boolean;

  @Expose({ name: 'pool_bonus' })
  poolBonus: boolean;

  @Expose({ name: 'payout_request' })
  payoutRequest: boolean;

  @Expose({ name: 'money_transfer' })
  moneyTransfer: boolean;

  @Expose({ name: 'wallet_management' })
  walletManagement: boolean;

  onboarding: boolean;
  language: boolean;
  currency: boolean;
  store: boolean;

  @Expose({ name: 'dynamic_link' })
  dynamicLink: boolean;

  @Expose({ name: 'cloud_messaging' })
  cloudMessaging: boolean;

  @Expose({ name: 'intro_video' })
  introVideo: boolean;

  passcode: boolean;

  @Expose({ name: 'intro_video_url' })
  introVideoUrl: string;

  @Expose({ name: 'support_message' })
  supportMessage: boolean;

  stories: boolean;
  events: boolean;

  @Expose({ name: 'android_app' })
  androidApp: boolean;

  @Expose({ name: 'ios_app' })
  iosApp: boolean;

  @Expose({ name: 'android_app_link' })
  androidAppLink?: string;

  @Expose({ name: 'ios_app_link' })
  iosAppLink?: string;

  kyc: boolean;
  crm: boolean;

  @Expose({ name: 'ticketing_system' })
  ticketingSystem: boolean;

  replica: boolean;
  lcp: boolean;

  @Expose({ name: 'business_volume' })
  businessVolume: boolean;

  constructor(
    compensationPlan: CompensationPlan,
    packages: boolean,
    upgrade: boolean,
    autoship: boolean,
    rank: boolean,
    directBonus: boolean,
    unilevelBonus: boolean,
    repurchaseBonus: boolean,
    roiBonus: boolean,
    poolBonus: boolean,
    payoutRequest: boolean,
    moneyTransfer: boolean,
    walletManagement: boolean,
    onboarding: boolean,
    language: boolean,
    currency: boolean,
    store: boolean,
    dynamicLink: boolean,
    cloudMessaging: boolean,
    introVideo: boolean,
    passcode: boolean,
    introVideoUrl: string,
    supportMessage: boolean,
    stories: boolean,
    events: boolean,
    androidApp: boolean,
    iosApp: boolean,
    kyc: boolean,
    crm: boolean,
    ticketingSystem: boolean,
    replica: boolean,
    lcp: boolean,
    businessVolume: boolean,
    androidAppLink?: string,
    iosAppLink?: string
  ) {
    this.compensationPlan = compensationPlan;
    this.packages = packages;
    this.upgrade = upgrade;
    this.autoship = autoship;
    this.rank = rank;
    this.directBonus = directBonus;
    this.unilevelBonus = unilevelBonus;
    this.repurchaseBonus = repurchaseBonus;
    this.roiBonus = roiBonus;
    this.poolBonus = poolBonus;
    this.payoutRequest = payoutRequest;
    this.moneyTransfer = moneyTransfer;
    this.walletManagement = walletManagement;
    this.onboarding = onboarding;
    this.language = language;
    this.currency = currency;
    this.store = store;
    this.dynamicLink = dynamicLink;
    this.cloudMessaging = cloudMessaging;
    this.introVideo = introVideo;
    this.passcode = passcode;
    this.introVideoUrl = introVideoUrl;
    this.supportMessage = supportMessage;
    this.stories = stories;
    this.events = events;
    this.androidApp = androidApp;
    this.iosApp = iosApp;
    this.androidAppLink = androidAppLink;
    this.iosAppLink = iosAppLink;
    this.kyc = kyc;
    this.crm = crm;
    this.ticketingSystem = ticketingSystem;
    this.replica = replica;
    this.lcp = lcp;
    this.businessVolume = businessVolume;
  }

  static fromJson(json: Record<string, any>): Module {
    return plainToInstance(Module, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
